module.exports = __webpack_public_path__ + "assets/select.2abf34aa.svg";